export default __webpack_public_path__ + "static/media/material-didatico.b5ab6fdc.pdf";